module.exports = __webpack_public_path__ + "static/media/hudsonheadshot.5cc0f72f.jpg";